// Spalla v0.3.1-19
// https://spalla.io
//
!(function () {
  var scr = document.createElement('script');
  var head = document.head || document.getElementsByTagName('head')[0];
  scr.async = false;
  scr.defer = false;
  scr.id = 'spalla-player-js';
  scr.src = 'https://beyond.spalla.io/player/js/spalla.min.js?_v=v0.3.1-19';
  head.insertBefore(scr, head.firstChild);
})('undefined' != typeof self ? self : 'undefined' != typeof window ? window : 'undefined' != typeof global ? global : this);